
export default {
  data() {
    return {
      value: 0
    };
  },
  props: {
    config: {},
    selectedRestaurant: {}
  },
  beforeMount() {
    this.initVal();
  },
  watch: {
    selectedRestaurant() {
      this.initVal();
    }
  },
  methods: {
    initVal() {
      this.value = this.config.value;
    },
    handleIncrement() {
      this.value += this.config.incrementBy;
      this.$emit("change", this.value);
    },
    handleDecrement() {
      this.value -= this.config.incrementBy;
      this.$emit("change", this.value);
    }
  }
};
